import React, { useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import "../../Assets/css/MobileDropdownModal.css";

const MobileDropdownModal = ({
  isOpen,
  onClose,
  title,
  className,
  children,
  userData,
  disableOutsideClick = false,
}) => {
  const modalRef = useRef(null);
  const [height, setHeight] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const startY = useRef(0);
  const startHeight = useRef(0);

  useEffect(() => {
    function handleOutsideClick(e) {
      if (disableOutsideClick) return;
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }

    if (isOpen && !disableOutsideClick) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose, disableOutsideClick]);

  // Reset height when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setHeight(null);
    }
  }, [isOpen]);

  const handleDragStart = (e) => {
    startY.current = e.clientY;
    const currentHeight = modalRef.current
      ? modalRef.current.getBoundingClientRect().height
      : 0;
    startHeight.current = currentHeight;
    setIsDragging(true);
    e.currentTarget.setPointerCapture(e.pointerId);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    const deltaY = e.clientY - startY.current;
    let newHeight = startHeight.current - deltaY;

    // Bounds clamping
    const maxHeight = window.innerHeight - 60;
    const minHeight = 200;

    if (newHeight > maxHeight) newHeight = maxHeight;
    if (newHeight < minHeight) newHeight = minHeight;

    setHeight(newHeight);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  if (!isOpen) return null;

  return (
    <div
      className={`mobile-modal-overlay ${className || ""} ${
        isDragging ? "is-dragging" : ""
      }`}
    >
      <div
        className={`mobile-modal-box ${isDragging ? "is-dragging" : ""}`}
        ref={modalRef}
        style={{
          height: height ? `${height}px` : "auto",
        }}
      >
        <div
          className="mobile-modal-line"
          onPointerDown={handleDragStart}
          onPointerMove={handleDragMove}
          onPointerUp={handleDragEnd}
          onPointerCancel={handleDragEnd}
        ></div>
        <div
          className="mobile-modal-header"
          onPointerDown={handleDragStart}
          onPointerMove={handleDragMove}
          onPointerUp={handleDragEnd}
          onPointerCancel={handleDragEnd}
        >
          <h4 style={{ fontFamily: userData?.pageTheme?.pageFont }}>{title}</h4>
        </div>

        {/* Modal Content */}
        <div className="mobile-modal-content">
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default MobileDropdownModal;
